const revive = {};

revive.domInjection = (serviceUrl) => {
    if (serviceUrl) {
        let script = document.createElement('script');
        let node = document.getElementsByTagName('body')[0];

        script.type = 'text/javascript';
        script.defer = true;
        script.src = serviceUrl;
        node.appendChild(script);
    }
};

export default revive;